export default "__VITE_ASSET__DKvioYtJ__"